import{jsx as r,jsxs as e}from"react/jsx-runtime";import{isValidElement as t,cloneElement as a}from"react";import l from"tailwind-styled-components";import o from"clsx";const s=l.div`
  flex
  items-center
  my-4
`,m=l.hr`
  border-gray-200
  my-4

  dark:border-gray-600
`,i=l.div`
  border-l
  border-gray-200
  h-full
  min-h-[1rem]
  inline
  mx-3
  w-px

  dark:border-gray-600
`,n=l.span`
  text-sm
  font-medium
  text-typography-subtle

  dark:text-gray-400
`,c=({children:l,className:c,textAlign:d="left",orientation:p="horizontal",...f})=>{const x=o(c,{"mr-4":"left"===d,"ml-4":"right"===d,"mx-4":"center"===d});return l||"horizontal"!==p?"vertical"===p?r(i,{className:c,role:"separator"}):e(s,{...f,role:"separator",children:[["center","right"].includes(d)&&r(m,{className:"flex-1"}),t(l)?a(l,{...l.props,className:o(x,l.props.className)}):r(n,{className:x,children:l}),["center","left"].includes(d)&&r(m,{className:"flex-1"})]}):r(m,{...f,className:x,role:"separator"})};export{c as default};
